import type { IPullRequest } from '@skystone/shared';
import { pullRequestApi } from '@/services/pull-request-api';
import { useApi } from '@/hooks/useApi';
import { DataTable, ErrorBanner, PageHeader, PageLoading } from '@/components/ui';
import type { ColumnDef } from '@/components/ui';
import { buildRawColumns, buildStandardEmptyMessage, buildStandardTblSubtitle } from '@/lib/tbl-page-utils';
import { PageContainer } from '@/components/layout';

const pullRequestColumns: ColumnDef<IPullRequest>[] = buildRawColumns<IPullRequest>([
  { key: 'id', header: 'ID' },
  { key: 'pullRequestKey', header: 'Pull Request Key' },
  { key: 'repositoryId', header: 'Repository ID' },
  { key: 'repositoryName', header: 'Repository Name' },
  { key: 'fabricRepositoryId', header: 'Fabric Repository ID' },
  { key: 'productId', header: 'Product ID' },
  { key: 'productName', header: 'Product Name' },
  { key: 'pullRequestNumber', header: 'Pull Request Number' },
  { key: 'state', header: 'State' },
  { key: 'title', header: 'Title' },
  { key: 'isMerged', header: 'Is Merged' },
  { key: 'hasTest', header: 'Has Test' },
  { key: 'leadTimeHours', header: 'Lead Time Hours' },
  { key: 'additions', header: 'Additions' },
  { key: 'deletions', header: 'Deletions' },
  { key: 'createdDate', header: 'Created Date' },
  { key: 'mergedDate', header: 'Merged Date' },
  { key: 'archived', header: 'Archived' },
  { key: 'archivedAt', header: 'Archived At' },
  { key: 'fabricSynced', header: 'Fabric Synced' },
  { key: 'fabricSyncedAt', header: 'Fabric Synced At' },
  { key: 'createdAt', header: 'Created At' },
  { key: 'updatedAt', header: 'Updated At' },
]);

export function TblPullRequestsPage() {
  const { data: rows, loading, error } = useApi(() => pullRequestApi.getAll(), []);

  if (loading && !rows) {
    return <PageLoading />;
  }

  return (
    <PageContainer variant="wide" className="space-y-6">
      <PageHeader title="Tbl - pull_requests" subtitle={buildStandardTblSubtitle()} />
      <ErrorBanner message={error} />
      <DataTable
        data={rows ?? []}
        columns={pullRequestColumns}
        keyExtractor={(row) => row.id}
        enablePagination
        enableFilters
        emptyMessage={buildStandardEmptyMessage('pull request')}
      />
    </PageContainer>
  );
}
